import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { greenBayConfig } from "./data";

export default function GreenBayWIPage() {
  return <CityPageTemplate config={greenBayConfig} />;
}